import { Directive, HostListener, HostBinding, Output, EventEmitter, ElementRef } from '@angular/core';

interface FileDropData {
	fileList: FileList;
	items: DataTransferItemList;
}

@Directive({
	selector: '[appFileDropZone]'
})
export class FileDropZoneDirective {

	// Original Background of file-drop zone
	private originBackground: string;
	private originColor: string;
	//
	private dragBackground = 'lightgray';
	private dragColor = 'white';

	// Emit event on dropping files
	@Output() onDropFiles: EventEmitter<FileDropData> = new EventEmitter();

	constructor(
		private elem: ElementRef
	) {
	}
	// Bind background color of file-drop zone
	@HostBinding('style.background') private background: string;
	@HostBinding('style.color') private color: string;

	//
	@HostListener('dragenter', ['$event']) onDragstart(e: DragEvent) {
		console.log('eeeeeeennnnnnnnnnnnnnn');
		if (this.background !== this.dragBackground) {
			// Store background before chaning
			this.originBackground = this.elem.nativeElement.style.background;
			this.originColor = this.elem.nativeElement.style.color;
			// Change background
			this.background = this.dragBackground;
			this.color = this.dragColor;
		}
	}
	@HostListener('dragover', ['$event']) onDragover(e: DragEvent) {
		e.preventDefault();
		e.stopPropagation();
	}
	@HostListener('dragleave', ['$event']) onDragleave(e: DragEvent) {
		e.preventDefault();
		e.stopPropagation();
		// Change back background
		this.background = this.originBackground;
		this.color = this.originColor;
	}
	@HostListener('drop', ['$event']) onDrop(e: DragEvent) {
		e.preventDefault();
		e.stopPropagation();
		// Change back background
		this.background = this.originBackground;
		this.color = this.originColor;
		// Emit onDropFiles event
		this.onDropFiles.emit({
			fileList: e.dataTransfer.files,
			items: e.dataTransfer.items
		});
	}

}
